import React, { useContext } from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import FeedThumb from '../_partials/FeedThumb';

import s from './Feed.scss';

export interface Props {
  items: PapiDeviation[];
  profileOwnerUser: PapiUser;
  isOwner?: boolean;
}

const FeedWidget: React.FC<Props> = ({ items }) => {
  const isMobile = useContext(MobileContext);
  const RootComponent: any = isMobile ? SwipeSlider : 'div';

  return (
    <RootComponent className={s['root']}>
      {items.map((item: PapiDeviation) => (
        <FeedThumb
          key={`${item.typeId}-${item.deviationId}`}
          deviation={item}
          className={s['item']}
          withComments
          withWatch
        />
      ))}
    </RootComponent>
  );
};

export default FeedWidget;
